import { Subject } from 'rxjs';
import {
  ActionStream,
  collectRoutines,
  subscribeRoutine,
} from '@ardoq/rxbeach';
import { popoverRoutines } from 'components/popover/routines';
import { deleteModelsRoutines } from 'contextMenus/deleteModelsRoutine';
import { tagscapeRoutines } from 'tabview/tagscape/routines';
import { routines as tagRoutines } from 'streams/tags/routines';
import { tagsCollectionRoutines } from 'streams/tags/tags$';
import { routines as modelRoutines } from 'streams/models/routines';
import { routines as fieldRoutines } from 'streams/fields/routines';
import { routines as componentRoutines } from 'streams/components/routines';
import { routines as referenceRoutines } from 'streams/references/routines';
import { routines as dynamicFilterRoutines } from 'streams/dynamicFilters/routines';
import { routines as workspaceRoutines } from 'streams/workspaces/routines';
import { logError } from '@ardoq/logging';
import { routines as searchResultTableRoutines } from 'components/SearchResultTable/routines';
import { routines as presentationViewPaneRoutines } from 'presentation/viewPane/routines';
import { routines as presentationRoutines } from 'presentation/routines';
import { routines as slideNavigatorRoutines } from 'presentation/slideNavigator/routines';
import { contextSwitchRoutines } from 'presentation/contextSwitch/routines';
import { pptxExportRoutines } from 'presentation/pptxExport/routines';
import { routines as dashboardRoutines } from 'dashboard/routines';
import { filterRoutines } from 'streams/filters/routines';
import { usersRoutines } from 'streams/orgUsers/routine';
import { documentBrowserRoutines } from 'components/DocumentBrowser/routines';
import { currentUserRoutines } from 'streams/currentUser/routines';
import { ephemeralNotificationRoutines } from 'ephemeralNotification/routines';
import { routines as contextViewSettingsRoutines } from 'views/environmentals/viewSettings/routines';
import { routines as contextRoutines } from 'streams/context/routines';
import { graphItemClickedRoutines } from 'tabview/graphComponent/graphEvents/graphItemClickedRoutines';
import { urlClickedRoutines } from 'tabview/graphViews/urlClickedRoutines';
import { createTranslationRoutines } from 'streams/translationSync';
import { LOCALE_BUNDLES } from 'localeResources';

const error$ = new Subject<any>();

export const getPresentationRoutines = () => {
  const routines = [
    componentRoutines,
    referenceRoutines,
    deleteModelsRoutines,
    dynamicFilterRoutines,
    fieldRoutines,
    filterRoutines,
    modelRoutines,
    popoverRoutines,
    presentationViewPaneRoutines,
    presentationRoutines,
    searchResultTableRoutines,
    tagRoutines,
    tagsCollectionRoutines,
    tagscapeRoutines,
    workspaceRoutines,
    slideNavigatorRoutines,
    contextSwitchRoutines,
    pptxExportRoutines,
    dashboardRoutines,
    usersRoutines,
    documentBrowserRoutines,
    currentUserRoutines,
    ephemeralNotificationRoutines,
    contextViewSettingsRoutines,
    contextRoutines,
    graphItemClickedRoutines,
    urlClickedRoutines,
    createTranslationRoutines(LOCALE_BUNDLES),
  ];

  return collectRoutines(...routines);
};

export function startPresentationRoutines(action$: ActionStream) {
  const routineSubscription = subscribeRoutine(
    action$,
    getPresentationRoutines(),
    error$
  );
  const errorSubscription = error$.subscribe(error =>
    logError(error, 'Routine error')
  );

  if (module.hot) {
    module.hot.dispose(() => {
      routineSubscription.unsubscribe();
      errorSubscription.unsubscribe();
    });
  }
}
